import SelfSchedulingContextProvider from 'lib/context/SelfSchedulingContext/SelfSchedulingContextProvider';
import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const SelfSchedulingV2 = withLazyFallback(
  () => import('components/Patient/SelfSchedulingV2/SelfSchedulingV2')
);

const Terms = withLazyFallback(() => import('components/Terms'));
const Unsubscribe = withLazyFallback(() => import('components/Unsubscribe/Unsubscribe'));

const SELF_SCHEDULING = [
  {
    path: 'book', // TODO: @rasim discuss to rename this to self-scheduling
    element: (
      <SelfSchedulingContextProvider>
        <SelfSchedulingV2 />
      </SelfSchedulingContextProvider>
    )
  },
  { path: 'terms', element: <Terms /> },
  { path: 'unsubscribe', element: <Unsubscribe /> }
];

export default SELF_SCHEDULING;
